import { Box, Fade, IconButton, Modal, Typography } from "@mui/material";
import { BACKGROUND_COLOR,BOX_SHADOW,BORDER_RADIUS } from "./Constants";
import {Close as CloseIcon,} from '@mui/icons-material';

// Reusable Modal Component
export const   CustomModal = ({ open, onClose, title, children }) => {
  return (<div>  <Modal open={open} onClose={onClose}>
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: '#FFFFFF',
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            p: 4,
            borderRadius: '16px',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">{title}</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {children}
        </Box>
      </Fade>
    </Modal>
    </div>
  );};
  